import { openPopup } from '../components/popups';
import { lenis } from './smoothScroll';

const getPageY = () => (typeof lenis?.scroll === 'number' ? lenis.scroll : window.scrollY);

const getElementDocumentTop = (el) => el.getBoundingClientRect().top + getPageY();

const getStickyOffset = (el) => {
	const stickyTop = parseFloat(getComputedStyle(el).top);
	return Number.isFinite(stickyTop) ? stickyTop : 0;
};

const getScrollToY = (el) => {
	const section = el.closest('.stacked-content-media');

	// Sticky rows shift their own offset once you scroll past the stack.
	// Measure from the section (not sticky) and add each previous row's height.
	if (section && el.classList.contains('stacked-content-media__row')) {
		const rows = [...section.querySelectorAll('.stacked-content-media__row')];
		const index = Math.max(0, rows.indexOf(el));
		let y = getElementDocumentTop(section);

		for (let i = 0; i < index; i++) {
			y += rows[i].offsetHeight;
		}

		return Math.max(0, y - getStickyOffset(el));
	}

	return Math.max(0, getElementDocumentTop(el) - getStickyOffset(el));
};

const urlParams = () => {
    // Initial setup of link listeners
    setupLinkListeners();

    // Check for URL params on load
    setTimeout(() => {
        handleURLParamsFunctionality(window.location.href);
    }, 750);
}

const setupLinkListeners = () => {
    let allATags = document.querySelectorAll('a');

	console.log(allATags);
    allATags.forEach((aTag) => {
        let linkHref = aTag.getAttribute('href');
        if (linkHref && linkHref.indexOf("#") !== -1) {
            // Check if the event listener is already attached
            if (!aTag.classList.contains('listener-attached')) {
                aTag.addEventListener('click', handleLinkClick);
                aTag.classList.add('listener-attached');
            }
        }
    });
}

const handleLinkClick = (event) => {
    event.preventDefault();
    let targetEl = event.target.closest('a').getAttribute('href');
    handleURLParamsFunctionality(targetEl);
    return false;
}

function handleURLParamsFunctionality(href){
	if ( href.indexOf("#") != -1 ) { // Check if the link has a #
		const hashRaw = href.split('#')[1];
		const hashValue = hashRaw.split(':');

		console.log(hashValue);

		if( hashValue[0] === 'book' ) {	// Shortcut to open booking widget
			// Open the reservations popup
			openPopup('#reservations');
		} else if ( hashValue[0] === 'newsletter' ) {
			openPopup('#newsletter');
		} else if ( hashValue[0] === 'main-nav' ) {
			openPopup('#main-nav');
		} else if ( hashValue[0] === 'reservations' ) {
			openPopup('#reservations');
		} else if ( hashValue[0] === 'scrollTo' ){ // Scroll to the element!
			let elementToScrollTo = document.querySelector('#' + hashValue[1]);

			if ( elementToScrollTo ) {
				const locationPageSubnavs = document.querySelectorAll(".m__lsubnav");

				if ( locationPageSubnavs ) {
					document.querySelector('body').classList.remove('js-popup-active');

					locationPageSubnavs.forEach((subnav) => {
						subnav.classList.remove('open');
					});
				}

				lenis.scrollTo(getScrollToY(elementToScrollTo), { duration: 1.2, force: true });
			}
		} else if ( hashValue[0] == 'popup' ) { // Open a custom popup
			if ( hashValue[1] != null && hashValue[1] > '' ) {
				openPopup('#'+hashValue[1]);
			}
		} else {
			return false;
		}
	}
}

urlParams();